import { PropsWithChildren } from 'react';

import { Link } from '@xing-com/link';

type Props = {
  link?: string;
  trackingParams?: string;
};

export const CompanyLink: React.FC<PropsWithChildren<Props>> = ({
  link,
  trackingParams,
  children,
}) => {
  if (!link) {
    return <>{children}</>;
  }

  const urlWithTrackingParams = `${link}?${trackingParams}`;
  return <Link to={urlWithTrackingParams}>{children}</Link>;
};
